import React, { useState } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Chip, 
  Box, 
  Collapse, 
  List, 
  ListItem, 
  ListItemText, 
  Button,
  Divider,
  useTheme
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import WorkIcon from '@mui/icons-material/Work';
import BusinessIcon from '@mui/icons-material/Business';

const QuestionCard = ({ company, jobTitle, jobDescription, questions }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card 
      className="question-card" 
      sx={{ 
        mb: 3, 
        overflow: 'hidden',
        border: '1px solid rgba(0, 0, 0, 0.08)',
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BusinessIcon sx={{ color: theme.palette.primary.main, mr: 1 }} />
          <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
            {company}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WorkIcon sx={{ color: theme.palette.secondary.main, mr: 1, fontSize: '1rem' }} />
          <Typography variant="subtitle1" color="text.secondary">
            {jobTitle}
          </Typography>
        </Box>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {jobDescription}
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Chip 
            label={`${questions.length} Questions`} 
            size="small" 
            sx={{ 
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.primary.contrastText,
              fontWeight: 'bold'
            }} 
          />
          <Button
            onClick={handleExpandClick}
            endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            size="small"
            sx={{ color: theme.palette.primary.main }}
          >
            {expanded ? 'Hide Questions' : 'View Questions'}
          </Button>
        </Box>
      </CardContent>
      
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider />
        <List sx={{ bgcolor: alpha(theme.palette.primary.light, 0.05) }}>
          {questions.map((question, index) => (
            <React.Fragment key={index}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      variant="body1"
                      sx={{ fontWeight: 500, color: theme.palette.text.primary }}
                    >
                      {question}
                    </Typography>
                  }
                />
              </ListItem>
              {index < questions.length - 1 && <Divider component="li" />}
            </React.Fragment>
          ))}
        </List>
      </Collapse>
    </Card>
  );
};

export default QuestionCard;